import { FileContainer } from '../domain/FileContainer';
import { Point } from '@view-model/models/common/basic';
import type { CommandManager } from '@model-framework/command';
import { CompositeCommand, CreateCommand } from '@model-framework/command';
import { ObjectRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import type { FileContainerId, GroupId, ModelId, ViewModelId } from 'balus-common';
import { FileContainerAssetTrashCommand } from '../command/FileContainerAssetTrashCommand';

export class FileContainerCreationOperation {
  static create({
    groupId,
    viewModelId,
    modelId,
    commandManager,
    position,
    attrs,
  }: {
    groupId: GroupId;
    viewModelId: ViewModelId;
    modelId: ModelId;
    commandManager: CommandManager;
    position: Point;
    attrs: Parameters<typeof FileContainer.buildNew>[0];
  }): FileContainerId {
    const container = FileContainer.buildNew(attrs);
    const { id } = container;

    const containerRepository = new ObjectRepository(
      FileContainer,
      RTDBPath.FileContainer.containerPath(viewModelId, modelId, id)
    );
    const positionRepository = new ObjectRepository(
      Point,
      RTDBPath.FileContainer.positionPath(viewModelId, modelId, id)
    );

    FileContainerAssetTrashCommand.executeCreation(
      commandManager,
      { groupId, viewModelId },
      [container.assetId],
      new CompositeCommand(
        new CreateCommand(container, containerRepository),
        new CreateCommand(position, positionRepository)
      )
    );

    return id;
  }
}
